
/*
 * Search toggles
 */


// Global vars
var biro_search_form;


// On page load
jQuery(function($) {

	// Init
	biro_search_form = $('#menu-search-form');
	var search_width;

	// Desktop search toggle
	$('#menu-search-toggle').on( 'click focus', function() {

		if ( ! biro_search_form.hasClass('is-active') ) {

			if ( biro_vw_xlg ) {
				search_width = 370;
			} else {
				search_width = 280;
			}

			biro_search_form.animate(
				{ width: search_width },
				200,
				function() {
					biro_search_form.addClass('is-active').find( '.menu-search-text' ).focus();
				}
			);

		} else {

			biro_search_form.animate(
				{ width: 0 },
				200,
				function() {
					biro_search_form.removeClass('is-active').find( '.menu-search-text' ).blur();
				}
			);

		}

	});

});
